module.exports = __webpack_public_path__ + "img/jd.79229e59.png";